import React from 'react';
import './blog-post.css';

import serviceday from './pictures/serviceday.jpg';
import serviceday1 from './pictures/serviceday1.jpg';
import serviceday3 from './pictures/serviceday3.jpg';

const Serviceday = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Service Day Recap</h2>
                    <p class="site-post-meta">May 24th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    We collboared with a total of 9 other RSOs for for Service Day hosted by UBC x COM^2! 
                    Thank you to everyone who lent a hand this past Friday! The Service Day is about fostering a 
                    community, so we are happy to see it come to life through the hard work of so many RSO student leaders!

                    We are overjoyed to give back to Seattle Children's Hospital, Color A Smile, and Elizabeth Gregory Home.
                    <br></br>
                     
                    </p>
                    <img src={serviceday} alt="Group picture"/>
                    <img src={serviceday1} alt="Working on kits"/>
                    <img src={serviceday3} alt="Seattle Children's Hospital kits"/>
                   
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Serviceday;

